module.exports = "/img/sms.png?59d6db34c1b342bb98736b6d10c35f8a";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/sms.png
// module id = VgXy
// module chunks = 80